/**
 * Map a profile response onto the shape the profile meta lists render.
 *
 * Shared by the person modal (public profiles) and the profile page,
 * so the directory-vs-affiliation rules live in one place.
 *
 * @param {object} profile Public or current-profile payload.
 */
export function toPersonShape(profile) {
  const name = profile?.identity?.name ?? {};
  const affiliation = profile?.affiliations?.[0] ?? {};
  const directory = profile?.directory ?? {};
  const inDirectory = !!directory.synced;

  return {
    displayName: name.full || name.display || '',
    firstName: name.first || '',
    lastName: name.last || '',
    audienceLabel: profile?.audience?.label || '',
    // The audience group is only explained on your own profile.
    isCurrentUser: Boolean(profile?.is_current_user),
    departments: inDirectory
      ? (directory.departments ?? [])
      : [affiliation.department].filter(Boolean),
    researchAreas: directory.research_areas ?? [],
    // Students carry no affiliation title: the presenter withholds it, because it is
    // the raw string their degree programme was parsed out of.
    titles: inDirectory ? (directory.titles ?? []) : [affiliation.title].filter(Boolean),
    // A degree programme is a student thing, and students are not in the public
    // directory. Anyone who is in it has no programme to show.
    program: inDirectory ? '' : affiliation.program || '',
    programYear: inDirectory ? '' : affiliation.program_year || '',
    offices: directory.offices ?? [],
    officeAddress: directory.office || '',
    email: profile?.identity?.email || '',
    phone: directory.phone || '',
    bio: profile?.bio || '',
    // Server-sanitized HTML from the person's GSD website page; faculty mostly.
    description: directory.description || '',
    contacts: profile?.contacts ?? [],
  };
}
